<template>
  <section class="adv-section">
    <div class="wrapper">
      <h2 v-if="title" class="adv-section__title">{{ title }}</h2>
      <div v-if="previewText" class="adv-section__desc" v-html="sanitizeHtml(previewText)"></div>
      <ul class="adv-section__list">
        <li v-for="(item, index) in items" :key="`adv_item_${index}`" class="adv-section__item">
          <h4 class="adv-section__subtitle">{{ item.title }}</h4>
          <div v-if="item.text" class="adv-section__text" v-html="sanitizeHtml(item.text)"></div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
import './styles.scss';
import { sanitizeHtml } from '~/composables/sanitizeHtml';

interface Props {
  title: string;
  previewText?: string;
  items: {
    title: string;
    text: string;
  }[];
}

defineProps<Props>();
</script>

<style scoped></style>
